import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Scope } from 'informed';
import { Cell, Grid } from 'react-md';
import { forEach, get } from 'lodash-es';

import TextField from '../../Common/TextField';

import { isEmail, isPhone, isZIP } from '../Transform/utils';

/**
 *
 * Description: Extention fields Component used by a natural party.
 *
 * @class
 */
class ExtendedPartyFieldsComponent extends Component {
  render() {
    const { ...props } = this.props;
    // eslint-disable-next-line no-unused-vars
    const { value, strings, readOnly, items } = props;

    const isValidPhone = phone => {
      const status = isPhone(phone);
      const message = get(strings, 'validation.message.invalid_phone', 'Numéro de téléphone non valide');
      return { status, message };
    };
    const isValidEmail = email => {
      const status = isEmail(email);
      const message = get(strings, 'validation.message.invalid_email', 'Adresse mail non valide');
      return { status, message };
    };
    const isValidZip = zip => {
      const status = isZIP(zip);
      const message = get(strings, 'validation.message.invalid_zip', 'ZIP non valide');
      return { status, message };
    };

    const getItems = () => {
      const renderedItems = [];
      forEach(items, item => {
        switch (item) {
          case 'PHONE':
            renderedItems.push(
              <div key="phone" className={Cell.getClassName({ size: 6 })}>
                <TextField
                  className="field text"
                  key="phone"
                  field="phone"
                  id="field-phone"
                  name="phone"
                  shrink
                  label={strings['block.transform.party.field.phone.label']}
                  placeholder=""
                  // onChange={value => this.setState({ selectedValue: value })}
                  // value={selectedValue}
                  disabled={readOnly}
                  required
                  validation={isValidPhone}
                  strings={strings}
                />
              </div>
            );
            break;
          case 'EMAIL':
            renderedItems.push(
              <div key="email" className={Cell.getClassName({ size: 6 })}>
                <TextField
                  className="field text"
                  key="email"
                  field="email"
                  id="field-email"
                  name="email"
                  shrink
                  label={strings['block.transform.party.field.email.label']}
                  placeholder=""
                  // onChange={_value => this.setState({ selectedValue: _value })}
                  // value={selectedValue}
                  disabled={readOnly}
                  required
                  validation={isValidEmail}
                  strings={strings}
                />
              </div>
            );
            break;

          case 'ADDRESS':
            renderedItems.push(
              <Grid id="subscription-address" className="grid address" style={{ width: '100%' }}>
                {/* tips: to create array in scope => scope= {`extra[${index}]` */}
                <Scope scope="addresses[0]">
                  {/* STREET */}
                  <div key="name" className={Cell.getClassName({ size: 7 })}>
                    <TextField
                      className="field text"
                      key="street"
                      field="street"
                      id="field-street"
                      name="street"
                      shrink
                      label={strings['block.transform.party.field.street.label']}
                      placeholder=""
                      // onChange={value => this.setState({ selectedValue: value })}
                      // value={selectedValue}
                      disabled={readOnly}
                      required
                      strings={strings}
                    />
                  </div>
                  {/* ZIP */}
                  <div key="zip" className={Cell.getClassName({ size: 2 })}>
                    <TextField
                      className="field text"
                      key="zip"
                      field="zip"
                      id="field-zip"
                      name="zip"
                      shrink
                      label={strings['block.transform.party.field.zip.label']}
                      placeholder=""
                      // onChange={value => this.setState({ selectedValue: value })}
                      // value={selectedValue}
                      disabled={readOnly}
                      required
                      strings={strings}
                      validation={isValidZip}
                    />
                  </div>
                  {/* CITY */}
                  <div key="city" className={Cell.getClassName({ size: 3 })}>
                    <TextField
                      className="field text"
                      key="city"
                      field="city"
                      id="field-city"
                      name="city"
                      shrink
                      label={strings['block.transform.party.field.city.label']}
                      placeholder=""
                      // onChange={value => this.setState({ selectedValue: value })}
                      // value={selectedValue}
                      disabled={readOnly}
                      required
                      strings={strings}
                    />
                  </div>
                </Scope>
              </Grid>
            );
            break;

          default:
            break;
        }
      });
      return renderedItems;
    };
    return getItems();
  }
}

ExtendedPartyFieldsComponent.propTypes = {
  values: PropTypes.object, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  readOnly: PropTypes.bool.isRequired, // eslint-disable-line
  items: PropTypes.arrayOf(PropTypes.oneOf(['PHONE', 'EMAIL', 'ADDRESS'])),
};

ExtendedPartyFieldsComponent.defaultProps = {
  items: ['PHONE', 'EMAIL', 'ADDRESS'],
};

export default ExtendedPartyFieldsComponent;
